import { render } from "./HiddenViewCounter.vue?vue&type=template&id=38448924"
import script from "./HiddenViewCounter.vue?vue&type=script&lang=js"
export * from "./HiddenViewCounter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\zacha\\repos\\jhhe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__